<template>
  <div class="bg-color">
    <div class="head-top">
      <div class="logo">
        <img src="../assets/home/logo.png" alt />
      </div>
      <ul class="navs">
        <li
          class="item"
          v-for="item in lists"
          :key="item.title"
          :class="{'sub-item': item.child, 'active': item.active, 'show': item.show}"
          @mouseenter="show(item)"
          @mouseleave="hide(item)"
        >
          <template v-if="item.url !== undefined">
            <router-link :to="item.url" tag="span">{{item.title}}</router-link>
          </template>
          <template v-if="item.child">
            <span>{{item.title}}</span>
            <ul>
              <li v-for="subItem in item.child" :key="subItem.title">
                <router-link :to="subItem.url" tag="span">{{subItem.title}}</router-link>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lists: [
        {
          title: "首页",
          url: "/"
        },
        {
          title: "关于我们",
          match: "/about",
          child: [
            {
              title: "领袖风采",
              url: "/about#leaders"
            },
            {
              title: "集团概括",
              url: "/about#ground"
            },
            {
              title: "发展历程",
              url: "/about#development"
            },
            {
              title: "组织架构",
              url: "/about#organization"
            },
            {
              title: "企业荣誉",
              url: "/about#honor"
            }
          ]
        },
        {
          title: "新闻动态",
          match: "/news",
          child: [
            {
              title: "内部动态",
              url: "/news/inner"
            },
            {
              title: "外部动态",
              url: "/news/outer"
            }
          ]
        },
        {
          title: "产品业务",
          url: "/product"
        },
        {
          title: "代理加盟",
          url: "/join"
        },
        {
          title: "招贤纳士",
          url: "/talnet"
        },
        // {
        //   title: "商家入驻",
        //   url: "/enter"
        // }
      ]
    };
  },
  watch: {
    $route(to, from) {
      this.lists = this.lists.map(_ => {
        delete _.active;
        delete _.show;
        //当前遍历的_的url地址与to为到哪儿的地址相同
        if (_.url && _.url == to.path) {
          _.active = true;
        }
        if (_.child) {
          _.child.forEach(__ => {
            let temp = __.url.split(/[\#\?]/)[0];

            if (temp == to.path) {
              _.active = true;
            }
            if (to.path.indexOf(_.match) == 0) {
              _.active = true;
            }
          });
        }
        if (to.path == "/amap" && _.url == "/") {
          _.active = true;
        }
        return _;
      });
    }
  },
  methods: {
    show(item) {
      this.lists = this.lists.map(_ => {
        if (_ == item) {
          _.show = true;
        }
        return _;
      });
    },
    hide(item) {
      this.lists = this.lists.map(_ => {
        delete _.show;
        return _;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.bg-color {
  background: #fff;
  box-shadow: 0 0px 15px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 999;

  .head-top {
    width: 1200px;
    height: 68px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .logo {
      width: 159px;
      height: 46px;
      line-height: 68px;
      img {
        width: 100%;
        height: 48px;
        vertical-align: middle;
      }
    }
    .navs {
      .item {
        float: left;
        padding: 0 24px;
        position: relative;
        cursor: pointer;
        & > span {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          display: inline-block;
          line-height: 64px;
          border-bottom: 2px solid transparent;
        }
        &.active > span {
          font-weight: 500;
          border-bottom: 2px solid #333333;
        }
        ul {
          position: relative;
          top: 8px;
          z-index: 999;
          background: #fff;
          border-radius: 4px;
          padding: 0 12px;
          width: 112px;
          opacity: 0;
          transform: scaleY(0);
          transform-origin: center top;
          transition: all 0.2s ease;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
          height: 0;
          li {
            text-align: center;
            font-size: 16px;
            color: #333333;
            line-height: 16px;
            padding: 16px 0 15px 0;
            border-bottom: 1px solid #eeeeee;
          }
        }
        &.show > ul {
          height: auto;
          opacity: 1;
          transform: scaleY(1);
        }
        &.sub-item {
          text-align: center;
          padding: 0;
          z-index: 999;
          & > span {
            display: inline-block;
            margin: 0 24px;
          }
        }
      }
    }
  }
}
</style>


